function isVariant(definition) {
    return typeof definition === "object";
}

export { isVariant };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@motionone/dom/dist/state/utils/is-variant.es.js
// module id = ojkt
// module chunks = 0